(function () {
  'use strict';

  function initGallery(scope) {
    (scope || document).querySelectorAll('[data-ps-gallery]').forEach(function (gallery) {
      if (gallery.dataset.psGalleryReady === 'true') return;
      gallery.dataset.psGalleryReady = 'true';
      var main = gallery.querySelector('[data-ps-main-image]');
      gallery.querySelectorAll('[data-ps-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!main) return;
          main.src = btn.dataset.src || main.src;
          main.removeAttribute('srcset');
          gallery.querySelectorAll('[data-ps-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
          btn.classList.add('is-active');
        });
      });
    });
  }

  function initCollection(scope) {
    (scope || document).querySelectorAll('[data-ps-collection]').forEach(function (collection) {
      if (collection.dataset.psCollectionReady === 'true') return;
      collection.dataset.psCollectionReady = 'true';
      var cards = [].slice.call(collection.querySelectorAll('[data-ps-card]'));
      var title = collection.querySelector('[data-ps-collection-title]');
      var count = collection.querySelector('[data-ps-count]');
      collection.querySelectorAll('[data-size-filter]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var size = btn.dataset.sizeFilter;
          var visible = 0;
          collection.querySelectorAll('[data-size-filter]').forEach(function (x) { x.classList.remove('is-active'); });
          btn.classList.add('is-active');
          cards.forEach(function (card) {
            var sizes = (card.dataset.sizes || '').toLowerCase().split('|');
            var show = size === 'all' || sizes.indexOf(size.toLowerCase()) > -1;
            card.style.display = show ? 'flex' : 'none';
            if (show) visible++;
          });
          if (title) title.textContent = size === 'all' ? title.dataset.baseTitle : 'Streetwear in Größe ' + size;
          if (count) count.textContent = visible + ' Artikel' + (size === 'all' ? '' : ' in Größe ' + size);
        });
      });
    });
  }

  function initHeader(scope) {
    (scope || document).querySelectorAll('[data-ps-header]').forEach(function (header) {
      if (header.dataset.psHeaderReady === 'true') return;
      header.dataset.psHeaderReady = 'true';

      var navItems = [].slice.call(header.querySelectorAll('[data-ps-nav-item]'));
      var mobilePanel = header.querySelector('[data-ps-mobile-panel]');
      var mobileOpen = header.querySelector('[data-ps-mobile-open]');
      var mobileClose = header.querySelector('[data-ps-mobile-close]');
      var mobileBackdrop = header.querySelector('[data-ps-mobile-backdrop]');
      var searchPanel = header.querySelector('[data-ps-search-panel]');
      var searchOpen = header.querySelector('[data-ps-search-open]');
      var searchInput = header.querySelector('[data-ps-search-input]');

      function syncDropdownPositions() {
        var bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
        header.querySelectorAll('[data-ps-nav-panel]').forEach(function (panel) { panel.style.top = bottom + 'px'; });
      }

      function closeDesktopMenus(except) {
        navItems.forEach(function (item) {
          if (item === except) return;
          item.classList.remove('is-open');
          var trigger = item.querySelector('[data-ps-nav-trigger]');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        });
      }

      navItems.forEach(function (item) {
        var trigger = item.querySelector('[data-ps-nav-trigger]');
        if (!trigger) return;
        trigger.addEventListener('click', function (event) {
          event.preventDefault();
          var willOpen = !item.classList.contains('is-open');
          closeDesktopMenus(item);
          item.classList.toggle('is-open', willOpen);
          trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
          if (willOpen) syncDropdownPositions();
        });
      });

      function lockPage(locked) {
        document.documentElement.classList.toggle('ps-overlay-open', locked);
      }

      function openMobileMenu() {
        closeSearch();
        header.classList.add('is-mobile-open');
        if (mobilePanel) mobilePanel.setAttribute('aria-hidden', 'false');
        if (mobileOpen) mobileOpen.setAttribute('aria-expanded', 'true');
        lockPage(true);
        if (mobileClose) setTimeout(function () { mobileClose.focus(); }, 20);
      }

      function closeMobileMenu() {
        header.classList.remove('is-mobile-open');
        if (mobilePanel) mobilePanel.setAttribute('aria-hidden', 'true');
        if (mobileOpen) mobileOpen.setAttribute('aria-expanded', 'false');
        if (!header.classList.contains('is-search-open')) lockPage(false);
      }

      function openSearch() {
        closeMobileMenu();
        closeDesktopMenus();
        header.classList.add('is-search-open');
        if (searchPanel) searchPanel.setAttribute('aria-hidden', 'false');
        if (searchOpen) searchOpen.setAttribute('aria-expanded', 'true');
        lockPage(true);
        if (searchInput) setTimeout(function () { searchInput.focus(); }, 80);
      }

      function closeSearch() {
        header.classList.remove('is-search-open');
        if (searchPanel) searchPanel.setAttribute('aria-hidden', 'true');
        if (searchOpen) searchOpen.setAttribute('aria-expanded', 'false');
        if (!header.classList.contains('is-mobile-open')) lockPage(false);
      }

      if (mobileOpen) mobileOpen.addEventListener('click', openMobileMenu);
      if (mobileClose) mobileClose.addEventListener('click', closeMobileMenu);
      if (mobileBackdrop) mobileBackdrop.addEventListener('click', closeMobileMenu);
      if (searchOpen) searchOpen.addEventListener('click', openSearch);
      header.querySelectorAll('[data-ps-search-close]').forEach(function (btn) { btn.addEventListener('click', closeSearch); });

      document.addEventListener('click', function (event) {
        if (!header.contains(event.target)) closeDesktopMenus();
        else if (!event.target.closest('[data-ps-nav-item]')) closeDesktopMenus();
      });

      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        closeDesktopMenus();
        closeMobileMenu();
        closeSearch();
      });

      window.addEventListener('scroll', syncDropdownPositions, { passive: true });
      window.addEventListener('resize', function () {
        syncDropdownPositions();
        if (window.innerWidth > 990) closeMobileMenu();
        if (window.innerWidth <= 990) closeDesktopMenus();
      });
      syncDropdownPositions();
    });
  }

  function storageHas(key) {
    try {
      var raw = localStorage.getItem(key);
      if (!raw) return false;
      var until = parseInt(raw, 10);
      if (!until || Date.now() > until) {
        localStorage.removeItem(key);
        return false;
      }
      return true;
    } catch (e) { return false; }
  }

  function storageSet(key, days) {
    try {
      localStorage.setItem(key, String(Date.now() + days * 86400000));
    } catch (e) {}
  }

  function initNewsletter(scope) {
    (scope || document).querySelectorAll('[data-ps-newsletter]').forEach(function (popup) {
      if (popup.dataset.psNewsletterReady === 'true') return;
      popup.dataset.psNewsletterReady = 'true';
      var key = popup.dataset.storageKey || 'ps_newsletter';
      var delay = parseInt(popup.dataset.delay || '25000', 10);
      var days = parseInt(popup.dataset.dismissDays || '14', 10);
      var scrollDepth = parseInt(popup.dataset.scrollDepth || '40', 10);
      var exitIntentEnabled = popup.dataset.exitIntent === 'true';
      var pageType = popup.dataset.pageType || '';
      var closeButtons = popup.querySelectorAll('[data-ps-nl-close]');
      var success = popup.querySelector('.ps-nl__success');
      var error = popup.querySelector('.ps-nl__error');
      var form = popup.querySelector('form');
      var email = popup.querySelector('input[type="email"]');
      var delayReady = false;
      var intentReady = false;
      var delayTimer;
      var retryTimer;
      var previouslyFocused;

      function emit(action) {
        document.dispatchEvent(new CustomEvent('ps:newsletter', { detail: { action: action } }));
        if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: 'newsletter_popup_' + action });
      }

      function isVisible(element) {
        if (!element || element === popup || popup.contains(element)) return false;
        var style = window.getComputedStyle(element);
        var rect = element.getBoundingClientRect();
        return style.display !== 'none' &&
          style.visibility !== 'hidden' &&
          rect.width > 0 && rect.height > 0 &&
          rect.right > 0 && rect.bottom > 0 &&
          rect.left < window.innerWidth && rect.top < window.innerHeight;
      }

      function hasBlockingOverlay() {
        var selectors = [
          '[aria-modal="true"]',
          'shopify-privacy-banner',
          '#shopify-pc__banner',
          '.shopify-pc__banner__dialog',
          '.ps-ask.is-open',
          '[data-shopify-cookie-banner]',
          'iframe[title*="cookie" i]',
          'iframe[title*="privacy" i]',
          'cart-drawer.active',
          '.drawer.active'
        ];
        return [].slice.call(document.querySelectorAll(selectors.join(','))).some(isVisible);
      }

      function cleanupTriggers() {
        window.clearTimeout(delayTimer);
        window.clearInterval(retryTimer);
        window.removeEventListener('scroll', onScroll);
        document.removeEventListener('mouseout', onExitIntent);
      }

      function show() {
        if (popup.classList.contains('is-visible') || hasBlockingOverlay()) return;
        cleanupTriggers();
        previouslyFocused = document.activeElement;
        popup.classList.add('is-visible');
        popup.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('ps-overlay-open');
        if (email && window.innerWidth > 749) setTimeout(function () { email.focus(); }, 120);
        emit('viewed');
      }

      function close(save, reason) {
        if (!popup.classList.contains('is-visible')) return;
        popup.classList.remove('is-visible');
        popup.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('ps-overlay-open');
        if (save !== false) storageSet(key, days);
        if (previouslyFocused && typeof previouslyFocused.focus === 'function') previouslyFocused.focus();
        emit(reason || 'dismissed');
      }

      function tryShow() {
        if (!delayReady || !intentReady || storageHas(key)) return;
        if (hasBlockingOverlay()) {
          if (!retryTimer) retryTimer = window.setInterval(tryShow, 1500);
          return;
        }
        show();
      }

      function onScroll() {
        var maxScroll = Math.max(document.documentElement.scrollHeight - window.innerHeight, 0);
        var pct = maxScroll === 0 ? 100 : (window.scrollY / maxScroll) * 100;
        if (pct >= scrollDepth) {
          intentReady = true;
          tryShow();
        }
      }

      function onExitIntent(event) {
        if (event.relatedTarget === null && event.clientY <= 5) {
          intentReady = true;
          tryShow();
        }
      }

      closeButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          close(true, btn.classList.contains('ps-nl__backdrop') ? 'backdrop_closed' : 'dismissed');
        });
      });
      document.addEventListener('keydown', function (event) {
        if (!popup.classList.contains('is-visible')) return;
        if (event.key === 'Escape') {
          close(true, 'escape_closed');
          return;
        }
        if (event.key !== 'Tab') return;
        var focusable = [].slice.call(popup.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'));
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
      if (email) email.addEventListener('focus', function () { emit('form_focused'); }, { once: true });
      if (form) form.addEventListener('submit', function () { emit('submitted'); });

      var inEditor = !!window.Shopify && !!window.Shopify.designMode;
      if (inEditor) return;
      if (pageType === 'cart') return;
      if (success) {
        storageSet(key, 365);
        show();
        return;
      }
      if (error) {
        show();
        return;
      }
      if (storageHas(key)) return;
      delayTimer = window.setTimeout(function () {
        delayReady = true;
        tryShow();
      }, Math.max(delay, 10000));
      window.addEventListener('scroll', onScroll, { passive: true });
      if (exitIntentEnabled && window.matchMedia('(hover: hover)').matches) document.addEventListener('mouseout', onExitIntent);
      document.addEventListener('visitorConsentCollected', tryShow);
      onScroll();
    });
  }



  function syncCartUI(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;
    var count = cart.item_count;
    var cartLink = document.querySelector('.ps-header__cart');
    if (cartLink) {
      var bubble = cartLink.querySelector('.ps-header__cart-count');
      if (count <= 0) {
        if (bubble) bubble.remove();
      } else {
        if (!bubble) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble ps-header__cart-count';
          bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
          cartLink.appendChild(bubble);
        }
        var visibleCount = bubble.querySelector('span[aria-hidden="true"]');
        if (visibleCount) visibleCount.textContent = count < 100 ? String(count) : '99+';
        var hiddenCount = bubble.querySelector('.visually-hidden');
        if (hiddenCount) hiddenCount.textContent = count + ' Artikel im Warenkorb';
      }
    }

    document.querySelectorAll('[data-ps-mobile-cart]').forEach(function (link) {
      link.textContent = count > 0 ? 'Warenkorb (' + count + ')' : 'Warenkorb';
    });
  }

  function refreshCartUI() {
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) { if (cart) syncCartUI(cart); return cart; })
      .catch(function () { return null; });
  }

  window.PSCartUI = window.PSCartUI || {};
  window.PSCartUI.refresh = syncCartUI;
  window.PSCartUI.fetchAndRefresh = refreshCartUI;

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { refreshCartUI(); });
  }

  function initAll(scope) {
    initGallery(scope);
    initCollection(scope);
    initHeader(scope);
    initNewsletter(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
